import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useAtom } from 'jotai';
import { filtersAtom, filtersResetAtom, currentPageAtom } from 'global/store';
import { Box } from '@xstyled/styled-components';
import FilterType from '../FilterType';
import Checkbox from '@/UI/Form/Checkbox';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { useRouter } from 'next/router';

export default function CustomAttributeFilter({ title, attribute, options }) {
  const sortedOptions = options?.sort((a, b) => a.label.localeCompare(b.label));

  const [filters, setFilters] = useAtom(filtersAtom);
  const [filtersReset, setFiltersReset] = useAtom(filtersResetAtom);
  const [currentPage, setCurrentPage] = useAtom(currentPageAtom);

  const { watch, reset, control, setValue } = useForm();
  const fields = watch();

  //filtrid

  const toggleCheckbox = (name, value) => {
    setValue(name, !fields[name]);

    const applyFilter = filter => {
      setFilters({ ...filters, [`${attribute}`]: filter });
      window.scrollTo(0, 0);
    };

    if (fields[name]) {
      applyFilter([]);
    } else {
      setCurrentPage(1);

      applyFilter([...filters[`${attribute}`], value]);
    }
  };

  useEffect(() => {
    if (filtersReset) {
      reset();
      setCurrentPage(1);

      setTimeout(() => setFiltersReset(false), 1000);
    }
  }, [filtersReset]);

  useEffect(() => {
    const selectedValues = sortedOptions?.filter(item => {
      return Object.values(filters)?.flat().includes(item.value);
    });

    if (selectedValues?.length) {
      selectedValues.forEach(item => {
        setValue(item.name, item.value);
      });
    }
  }, [filters]);

  return (
    <FilterType title={title}>
      {sortedOptions?.map(({ name, label, value }) => {
        return (
          <FlexBox
            key={label}
            align="center"
            justify="space-between"
            w={240}
            lineHeight={2}
          >
            <Controller
              name={name}
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  onChange={() => toggleCheckbox(name, value)}
                  label={label}
                  cursor="pointer"
                />
              )}
            />
            <Box as="span" pl={8} color="lightgray"></Box>
          </FlexBox>
        );
      })}
    </FilterType>
  );
}
